import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsEye, BsEyeSlash, BsInfoCircle, BsLock, BsPerson, BsBoxArrowInRight, BsMortarboard } from 'react-icons/bs';
import { login, loginGuru } from '../services/authService';
import logo from '../assets/EPRAJOGO1.png';

function LoginPage() {
  const navigate = useNavigate();
  const [account, setAccount] = useState('');
  const [role, setRole] = useState('siswa');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const result = role === 'guru'
        ? await loginGuru(account.trim(), password)
        : await login(account.trim(), password);
      setMessage(result.message || (result.success ? 'Login berhasil.' : 'Login gagal.'));
      setIsSuccess(Boolean(result.success));

      if (result.success) {
        navigate(role === 'guru' ? '/guru' : '/dashboard', { replace: true });
      }
    } catch (_) {
      setMessage('Tidak dapat terhubung ke server. Periksa koneksi lalu coba lagi.');
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const chooseRole = (nextRole) => {
    setRole(nextRole);
    setMessage('');
  };

  return (
    <main className="auth-page">
      <div className="auth-shell">
        <header className="auth-brand">
          <img src={logo} alt="Logo E-Prajogo" className="auth-logo" />
          <h1>E-PRAJOGO</h1>
          <p>SMK NEGERI GUDO</p>
          <small>Presensi, jurnal, dan penilaian PKL dalam satu layanan</small>
        </header>

        <section className="auth-content">
          {message && (
            <div className={`alert ${isSuccess ? 'alert-success' : 'alert-danger'} py-2 small rounded-3`} role="status">
              {message}
            </div>
          )}

          <div className="auth-role-switch" role="group" aria-label="Masuk sebagai">
            <button
              type="button"
              className={`auth-role-option ${role === 'siswa' ? 'active' : ''}`}
              aria-pressed={role === 'siswa'}
              onClick={() => chooseRole('siswa')}
            >
              <BsMortarboard className="me-2" /> Siswa
            </button>
            <button
              type="button"
              className={`auth-role-option ${role === 'guru' ? 'active' : ''}`}
              aria-pressed={role === 'guru'}
              onClick={() => chooseRole('guru')}
            >
              <BsPerson className="me-2" /> Pembimbing
            </button>
          </div>

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="account" className="form-label">{role === 'guru' ? 'NIP / Username' : 'NISN'}</label>
              <div className="input-group auth-input-group">
                <span className="input-group-text"><BsPerson /></span>
                <input
                  type="text"
                  id="account"
                  className="form-control"
                  placeholder={role === 'guru' ? 'Masukkan NIP / Username' : 'Masukkan NISN'}
                  value={account}
                  onChange={(event) => setAccount(event.target.value)}
                  autoComplete="username"
                  inputMode={role === 'siswa' ? 'numeric' : 'text'}
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="form-label">Kata Sandi</label>
              <div className="input-group auth-input-group">
                <span className="input-group-text"><BsLock /></span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  className="form-control"
                  placeholder="Masukkan kata sandi"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  autoComplete="current-password"
                  required
                />
                <button
                  className="input-group-text"
                  type="button"
                  aria-label={showPassword ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'}
                  onClick={() => setShowPassword((visible) => !visible)}
                >
                  {showPassword ? <BsEyeSlash /> : <BsEye />}
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary auth-submit w-100 d-flex align-items-center justify-content-center" disabled={isLoading}>
              {isLoading
                ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Memproses...</>
                : <><BsBoxArrowInRight className="me-2" />Masuk ke E-Presensi</>}
            </button>
          </form>

          <div className="auth-hint mt-3">
            <BsInfoCircle className="me-2 text-primary" aria-hidden="true" />
            Siswa masuk menggunakan NISN. Pembimbing menggunakan NIP atau username akun guru.
          </div>
          <p className="small text-center mt-4 mb-0" style={{ color: 'var(--app-muted)', fontSize: 10 }}>
            Layanan resmi SMK Negeri Gudo • Hubungi operator sekolah jika mengalami kendala
          </p>
        </section>
      </div>
    </main>
  );
}

export default LoginPage;
